<template>
  <div class="function-edit">
    <p class="page-title">{{`${$route.params.id === '0' ? `新建` : `编辑`}数据字典`}}</p>
    <el-button class="pull-right" type="primary" plain size="mini" @click.prevent="cancel()"><i class="el-icon-back"></i>返回</el-button>
    <div class="page-card">
      <div class="page-section">
        <el-form :model="this" :rules="rules" label-width="100px" :inline="true" class="demo-form-inline mt25">
          <!-- <el-form-item label="id" prop="id">
            <el-input :disabled="$route.params.id !== '0'" class="input100" v-model="id" placehoder="请填写ID"></el-input>
          </el-form-item> -->
          <el-form-item :label="`名称`" prop="name">
            <el-input class="input250" v-model="name" :placeholder="`请输入`" type="textarea"></el-input>
          </el-form-item>
          <el-form-item :label="`数值`" prop="value">
            <el-input class="input100" v-model="value" :placeholder="`请输入`"></el-input>
          </el-form-item>
          <el-form-item label="parent_id" prop="parent_id">
            <el-select class="input200" clearable filterable v-model="parent_id" @clear="selectionParent" :disabled="!!pageId" :placeholder="`请选择`">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="type" prop="type">
            <el-input class="input100" v-model="type" :disabled="!!pageId || !!parent_id" :placeholder="`请输入`"></el-input>
          </el-form-item>
          <el-form-item :label="`备注`" prop="remark">
            <el-input
              class="input120"
              v-model="remark"
              :placeholder="`请输入`"></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox :label="`是否可自定义`" v-model="customize"></el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-checkbox :label="`是否默认选中`" v-model="is_default"></el-checkbox>
          </el-form-item>
        </el-form>
        <div class="mt10">
          <el-button size="small" type="primary" @click="save()">保存</el-button>
          <el-button size="small" @click="cancel()">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { dictEdit, dictOption, dictList } from '@/api.js'
export default {
  name: 'ContainerEdit',
  data() {
    return {
      id: '',
      name: '',
      value: '',
      parent_id: '',
      type: '',
      remark: '',
      customize: false,
      is_default: false,
      pageId: 0,
      options: [],
      typeList: [],
      rules: {
        // parent_id: [
        //   { required: true, message: '请选择parent_id', trigger: 'blur' }
        // ],
        name: [
          { required: true, message: `名称`, trigger: 'blur' }
        ],
        value:[
          { required: true, message: `数值`, trigger: 'blur' }
        ],
        // type: [
        //   { required: true, message: '请输入type', trigger: 'blur' }
        // ]
      }
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  watch: {
    parent_id(newValue) {
      if (newValue) {
        // this.type = ''
        // this.typeList = this.options.filter(i => i.id === this.parent_id)[0] ? this.options.filter(i => i.id === this.parent_id)[0].son : []
        this.type = this.options.filter(i => i.id === this.parent_id)[0] ? this.options.filter(i => i.id === this.parent_id)[0].type : ''
      }

      
    }
  },
  async created() {
    this.pageId = Number(this.$route.params.id)
    await this.getOptions()
    if (this.pageId) {
      this.getDetail(this.pageId)
    }
  },
  methods: {
    async getOptions() {
      // 获取下拉选项数据
      const res = await this.$request('get', dictOption, {})
      if (res) {
        this.options = res
      }
    },
    async getDetail(id) {
      // 获取详情
      const url = dictEdit.replace('{id}', id)
      const res = await this.$request('get', url, {})
      if (res) {
        const { name, value, parent_id, type, can_customize, is_default, remark } = res

        this.name = name
        this.value = value
        this.parent_id = parent_id
        this.remark = remark
        this.is_default = !!is_default
        this.typeList = this.options.filter(i => i.id === this.parent_id)[0] ? this.options.filter(i => i.id === this.parent_id)[0].son : []
        this.customize = !!can_customize
        this.$nextTick(() => {
          this.type = type
        })
      }
    },
    async save() {
      // 保存
      const { name, value, parent_id, type, customize, pageId, is_default, remark } = this
      const isAdmin = this.user.type === 1
      const url = pageId ? dictEdit.replace('{id}', pageId) : dictList
      const info = {
        name,
        value,
        parent_id,
        type,
        is_default: is_default ? 1 : 0,
        remark,
        can_customize: isAdmin ? customize ? 1 : 0 : undefined
      }
      const res = await this.$request('post', url, info)
      if (res) {
        this.$message.success(`${pageId ? `编辑` : `创建`}成功`)

        this.cancel()
      }
    },
    cancel() {
      this.$router.back()
    },
    selectionParent() {
      this.type = ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .function-edit {
    position: relative;
  }
</style>

